<template>
  <div class="col-md-12">
    <div class="modal-body">
      <pre>Object 1 : {{ $store.getters.OBJECTDESCRIPTION }}</pre>
      <pre>Object 1 Type : {{ getObj(this.$store.getters.OBJECTTYPE) }}</pre>
      <label>Link Type</label>
      <select id="Select1" v-model="params.linktype" class="form-control">
        <option
          v-for="option in linktype"
          v-bind:value="option.type"
          v-bind:key="option.type"
        >
          {{ option.type }}
        </option>
      </select>
      <div v-if="obj1type">
        <label>Comments For Documents</label>
        <input type="text" v-model="additional" class="form-control" />
      </div>
      <label>Link Description</label>
      <textarea
        class="form-control"
        v-model="params.linkdesc"
        cols="5"
        rows="5"
      ></textarea>
    </div>
    <div class="modal-footer">
      <button class="btn btn-success" @click="submitLink()">Link Object</button>
    </div>
  </div>
</template>

<script>
import {
  authHeader,
  notifyHelper,
  RecordURL,
  LinkURL,
  getObjectType,
  responseCheck,
} from "../../helper";
import instance from "../../helper/http";
export default {
  data() {
    return {
      params: {
        obj1: this.$store.getters.OBJECT1ID,
        obj1t: this.$store.getters.OBJECTTYPE,
        obj2: this.$store.getters.OBJECT2ID,
        obj2t: this.$store.getters.OBJECT2TYPE,
        linktype: "",
        linkdesc: "",
      },
      obj1type: this.$store.getters.OBJECTTYPE === "DC" ? true : false,
      objtype: {
        type: "REFERENCE",
      },
      isDC: false,
      linktype: [],
      additional: "",
      
      //typedesc:''
    };
  },
  created: function () {
    this.getList();
    //this.typedesc = this.getObj(this.$store.getters.OBJECTTYPE)
  },
  methods: {
    getList() {
      instance
        .get(
          RecordURL +
            "getreltype?rel1=" +
            this.$store.getters.OBJECTTYPE +
            "&rel2=" +
            this.$store.getters.OBJECT2TYPE,
          {
            headers: authHeader(),
          }
        )
        .then((response) => {
          if (response.data.data.length < 1) {
            this.linktype = this.objtype;
          } else {
            this.linktype = response.data.data;
          }
        })
        .catch(function (error) {
          responseCheck(error.response.status);
        });
    },
    getObj: function (type) {
      return getObjectType(type);
    },
    submitLink() {
      if (this.params.linktype === "") {
        notifyHelper("warn", "please choose link type");
      } else {
        if (this.params.obj1t === "DC") {
          this.params.linkdesc = this.params.linkdesc + " " + this.additional;
          instance
            .get(LinkURL + "add_link", {
              params: this.params,
              headers: authHeader(),
            })
            .then((response) => {
              if (response.data.error) {
                notifyHelper("error", response.data.message);
              } else {
                notifyHelper("success", response.data.message);
              }
            })
            .catch(function (error) {
              responseCheck(error.response.status);
            });
        } else {
          instance
            .get(LinkURL + "add_link", {
              params: this.params,
              headers: authHeader(),
            })
            .then((response) => {
              if (response.data.error) {
                notifyHelper("error", response.data.message);
              } else {
                notifyHelper("success", response.data.message);
              }
            })
            .catch(function (error) {
              responseCheck(error.response.status);
            });
        }
      }
    },
  },
};
</script>

